import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, NgZone, Renderer2 } from '@angular/core';

@Directive({
  selector: '[kveDialogBackdrop]'
})
export class DialogBackdropDirective implements AfterViewInit{

  constructor(
    private el:ElementRef<HTMLElement>,
    private cdref: ChangeDetectorRef,
    private renderer: Renderer2,
    private ngZone: NgZone,) { }
  
  ngAfterViewInit(): void {
    console.log(this.el.nativeElement);
    let anchor = this.el.nativeElement
    let nbDialogContainer:HTMLElement = anchor.closest('NB-DIALOG-CONTAINER');
    nbDialogContainer.style.height = "100vh";
    nbDialogContainer.style.width = "100vw";
    let cdkOverlayBackdrop = <HTMLElement>nbDialogContainer.closest('.cdk-overlay-pane').closest('.cdk-global-overlay-wrapper').previousElementSibling;
    cdkOverlayBackdrop.style.background = "#fff";
    cdkOverlayBackdrop.style.opacity = "0.6";
    //let overLayWrapper = <HTMLElement>nbBialogContainer.closest('.cdk-overlay-pane').closest('.cdk-global-overlay-wrapper');
    let overLayWrapper = nbDialogContainer.closest('.cdk-overlay-pane')?.closest('.cdk-global-overlay-wrapper');
    if (overLayWrapper instanceof HTMLElement) {
      console.log(overLayWrapper);
      overLayWrapper.style.justifyContent = 'unset';
      overLayWrapper.style.alignItems = 'unset';
      //overLayWrapper.style.removeProperty('justify-content');
      //overLayWrapper.style.removeProperty('align-items');
      this.cdref.detectChanges();
      this.removeOverlayStyles();
    }

    //console.log(overLayWrapper);

   /* let nbBialogContainer:HTMLElement = this.titleHost.nativeElement.closest('NB-DIALOG-CONTAINER');
      if(nbBialogContainer){
        nbBialogContainer.style.width = this.dialogWidth+"px";
        nbBialogContainer.style.height = "100vh";
        nbBialogContainer.style.background = "#fff";
      }
      let customDialog:HTMLElement = nbBialogContainer.closest('.custom-dialog-class').closest('.cdk-global-overlay-wrapper');
      console.log(customDialog);
      customDialog.previousElementSibling
      let cdkOverlayBackdrop:HTMLElement = <HTMLElement>customDialog.previousElementSibling;
      console.log(cdkOverlayBackdrop);
      cdkOverlayBackdrop.style.background = "#fff";
      cdkOverlayBackdrop.style.opacity = "0.5"; */
  }

  // Your method:
removeOverlayStyles() {
  this.ngZone.runOutsideAngular(() => {
    setTimeout(() => {
      const wrapper = document.querySelector('.cdk-global-overlay-wrapper');
      if (wrapper) {
        this.renderer.removeStyle(wrapper, 'justify-content');
        this.renderer.removeStyle(wrapper, 'align-items');
        
        // Optional: Force change detection if needed
        this.ngZone.run(() => this.cdref.detectChanges());
      }
    });
  });
}

}
